import { observable } from 'mobx';

export type CalendarArgs = {
  id: string;
  auth_data_id: string;
  is_default?: boolean;
  name: string;
  email: string;
  provider: string | null;
  editable?: boolean;
  background_color?: string;
  foreground_color?: string;
};

export default class Calendar {
  @observable id: string;
  @observable authDataId: string;
  @observable isDefault: boolean;
  @observable name: string;
  @observable email: string;
  @observable provider: string | null;
  @observable editable: boolean;
  @observable backgroundColor: string | null;
  @observable foregroundColor: string | null;

  constructor(args: CalendarArgs) {
    this.id = args.id;
    this.authDataId = args.auth_data_id;
    this.isDefault = args.is_default || false;
    this.name = args.name;
    this.email = args.email;
    this.provider = args.provider;
    this.editable = typeof args.editable === 'boolean' ? args.editable : true;
    this.backgroundColor = args.background_color || null;
    this.foregroundColor = args.foreground_color || null;
  }

  submitParams() {
    return {
      id: this.id,
      provider: this.provider,
      auth_data_id: this.authDataId
    };
  }
}
